import { render, staticRenderFns } from "./Sinistre.vue?vue&type=template&id=766f8dca&"
import script from "./Sinistre.vue?vue&type=script&lang=js&"
export * from "./Sinistre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports